import {
	TAX_CONTACT_TYPE,
} from "./actionTypes";

export const setTaxContactType = taxContactType => ({
	type: TAX_CONTACT_TYPE,
	payload: taxContactType
});
